import React from 'react';

export const TsuDepositsModal = {
  title: 'Number Of Deposits',
  body: (
    <div>
      <p>
        The total number of deposits link will display the deposits associated with a particular tsunami event.
      </p>
    </div>
  ),
};
